import { useEffect, useState, useMemo } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui-custom/Dialog";
import Button from "../ui-custom/Button";
import { Input, Label } from "../ui-custom/Input";
import { Wallet } from "lucide-react";

export function UpdateSpendableLimitDialog({ open, onOpenChange, employee, onSubmit }) {
  const [spendableAmount, setSpendableAmount] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open && employee) {
      setSpendableAmount(String(employee.spendableAmount || 0));
    }
  }, [open, employee]);

  const handleSubmit = async () => {
    if (!employee) return;
    setSubmitting(true);
    try {
      await onSubmit?.(employee.id, parseFloat(spendableAmount) || 0);
      onOpenChange(false);
    } catch (e) {
      console.error("Failed to update spendable limit", e);
      alert(e?.message || "Failed to update spendable limit");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="p-2 bg-sm-secondary/10 rounded-lg">
              <Wallet className="w-5 h-5 text-sm-secondary" />
            </div>
            <div>
              <DialogTitle className="text-lg font-semibold">Update Spendable Limit</DialogTitle>
              <p className="text-xs text-text-gray">
                Set the amount {employee?.name} can spend without approval.
              </p>
            </div>
          </div>
        </DialogHeader>

        <div className="space-y-4 p-6 py-4">
          <div className="space-y-2">
            <Label className="text-sm font-medium">Spendable Amount (₹)</Label>
            <Input
              type="number"
              placeholder="0.00"
              value={spendableAmount}
              onChange={(e) => setSpendableAmount(e.target.value)}
              className="px-3"
            />
            <p className="text-[10px] text-text-gray italic">
              Current Balance: ₹{employee?.balance?.toLocaleString("en-IN")}
            </p>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={submitting}
            variant="accent"
          >
            {submitting ? "Updating..." : "Update Limit"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
